import React from 'react';

import {
    Flex,
    Grid,
    Text,
    Spacer,
} from "@chakra-ui/react";
import Alphabackground1 from "../assets/Alphabackground1.png";
import { Card } from "../components/Card";
import { CardBody } from "../components/CardBody";
import { useTronLink } from '../contexts/tronlink';
import { CardHeader } from '../components/CardHeader';

export const Home: React.FunctionComponent = () => {
    const { walletName } = useTronLink();


    return (
        <Flex flexDirection='column' pt={{ base: "90px", md: "10px" }}>
            <Grid
                templateColumns={{ sm: "1fr", md: "1fr 1fr", "2xl": "2fr 1.2fr 1.5fr" }}
                my='280px'
                mt='1px'
            >
                {/* Welcome Card */}
                <Card
                    p='0px'
                    gridArea={{ md: "1 / 1 / 2 / 3", "2xl": "auto" }}
                    bgImage={Alphabackground1}
                    bgSize='cover'
                    h="220px"
                    w="1205px"
                    borderRadius="20px"
                    shadow='2px 8px 10px 4px rgba(0, 0, 0, 0.3)'
                    variant={''}>

                    <CardBody w='100%' h='100%' variant={''}>
                        <Flex flexDirection={{ sm: "column", lg: "row" }} w='100%' h='100%'>
                            <Flex
                                flexDirection='column'
                                h='100%'
                                p='22px'
                                minW='60%'
                                lineHeight='1.6'>
                                <Text fontSize='lg' color='gray.300' fontWeight='bold'>
                                    Welcome,
                                </Text>
                                <Text fontSize='28px' color='#fff' fontWeight='bold' mb='18px'>
                                    {walletName}
                                </Text>
                                <Text
                                    fontSize='md'
                                    color='gray.300'
                                    fontWeight='normal'
                                    mb='auto'>
                                    Glad to see you! <br />
                                </Text>
                                <Spacer />
                                <Flex align='center'>
                                </Flex>
                            </Flex>
                        </Flex>
                    </CardBody>
                </Card>
            </Grid>

            <Grid
                templateColumns={{ sm: "1fr", md: "1fr 1fr", "2xl": "2fr 1.2fr 1.5fr" }}
                my='280px'
                mt='1px'
            >
                <Card
                    p='0px'
                    bgGradient='linear(to-l, #021D57, #0B6DFF)'
                    h="400px"
                    w="1205px"
                    borderRadius="20px"
                    shadow='2px 8px 10px 4px rgba(0, 0, 0, 0.3)'
                    variant={''}>
                    <CardHeader variant={""}
                    >
                        <Flex direction='column'
                            mt='34px'
                            align='center'
                            justify='center'
                        >
                            <Text color='#fff' fontSize='34px' fontWeight='bold'>
                                About Us
                            </Text>
                        </Flex>
                    </CardHeader>
                    <Flex direction='column' justify='center' align='center'>
                        <CardBody
                            w='950px'
                            h='100%'
                            variant={''}
                            display='flex'
                            alignContent={'center'}

                        >
                            <Text fontWeight='bold' mb='1rem' mt='10px' fontSize="20px" color='white'>
                                Alpha Finance is a Decentalized Finance Protocol and Service with the Secure and Transparency.<br />
                                We are here to solve the problem of people with : <br />
                                1 . analyze their wallets for security and credit scores. for loan applications,<br />
                                2. crypto loan services with smart contracts third-party systems, <br />
                                3.  not only that we also make it easy for people to make crypto purchases securely through fiat integration <br />
                                4. and servicing their transactions with Non-custodial private transactions <br />
                                5. also serves to secure their wallets with the multi-signature method <br />
                                6. provide services to find local areas that accept crypto payments

                            </Text>
                        </CardBody>
                    </Flex>
                </Card>
            </Grid>
        </Flex>
    )
}